import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";

import Box from "../utility/box";
import Block from "../Block";

import "./style.css";
import Anchor from "../Anchor";
import Space from "../Space";

class DetailList extends Component {
  getClickAction(child) {
    if (!child) return child;
    switch (child.eventType) {
      case "navigate":
      default:
        return null;
    }
  }
  getChild(child, index) {
    if (!child) return child;
    switch (child.type) {
      case "html":
        return (
          <Block
            key={index}
            className="detail-item--desc"
            dangerouslySetInnerHTML={{ __html: child.description }}
          />
        );
      case "clickable":
        return (
          <Anchor key={index} onClick={this.getClickAction(child)}>
            {child.description}
          </Anchor>
        );
      case "blankLink":
        return (
          <Anchor key={index} href={child.eventParams} target={child.target}>
            {child.description}
          </Anchor>
        );
      default:
        return (
          <Block
            key={index}
            style={{ color: child.color }}
            className="detail-item--desc"
          >
            {child.description}
          </Block>
        );
    }
  }
  createDetailChild = (child, index) => {
    return (
      <Block key={index} className="detail-item">
        <Block className="detail-item--title">{child.title}</Block>
        {child.description instanceof Array
          ? child.description.map((item, index) =>
              index !== child.description.length - 1 ? (
                <React.Fragment key={index}>
                  {this.getChild(item, index)}
                  <Space />
                </React.Fragment>
              ) : (
                this.getChild(item, index)
              )
            )
          : this.getChild(child, index)}
      </Block>
    );
  };
  createDetail = (detail, index) => {
    if (!detail) return detail;
    if (!detail.listItems) return detail.listItems;
    return (
      <Col key={index} xs={24} sm={12} md={6} lg={6}>
        <Box className="detail-box" title={detail.title}>
          {detail.listItems.map((child, index) =>
            this.createDetailChild(child, index)
          )}
        </Box>
      </Col>
    );
  };
  createDetailList = () => {
    const { detailList, title } = this.props;
    if (!detailList) return detailList;
    return (
      <Box className="detail-wrapper">
        <Block className="detail-title"> {title}</Block>
        <Row className="detail-layout" gutter={6} type="flex">
          {detailList.map((detail, index) => this.createDetail(detail, index))}
        </Row>
      </Box>
    );
  };
  render() {
    return this.createDetailList();
  }
}

DetailList.propTypes = {
  title: PropTypes.string,
  detailList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      listItems: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.any
        })
      ).isRequired
    })
  ).isRequired
};

export default DetailList;



// WEBPACK FOOTER //
// ./src/components/ui-ant/DetailList/index.js